import { defineMessages, type IntlShape } from 'react-intl';

import type { JSONSchema } from '@plone/types';
import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';

const addBlocksBg = ({
  schema,
  formData,
  intl,
}: {
  schema: JSONSchema;
  formData: JSONSchema;
  intl: IntlShape;
}): JSONSchema => {
  addStyling({ schema, intl, formData });

  // @ts-expect-error
  schema.properties.styles.schema.fieldsets[0].fields = [
    // @ts-expect-error
    ...schema.properties.styles.schema.fieldsets[0].fields,
    'bg',
  ];
  // @ts-expect-error
  schema.properties.styles.schema.properties['bg'] = {
    widget: 'color_picker',
    title: intl.formatMessage(messages.show_bg_title),
    colors: [
      {
        name: 'white',
        label: 'white',
      },
      { name: 'gray', label: 'Gray' },
      {
        name: 'black',
        label: 'Black',
      },
    ],
    default: 'white',
  };

  return schema;
};

export default addBlocksBg;
const messages = defineMessages({
  show_bg_title: {
    id: 'show_bg_title',
    defaultMessage: 'Block background',
  },
});
